import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { formatNumber } from "../../../utils/formatNumber";
import {
  Grid2,
  InputAdornment,
  TextField,
  Typography,
  Box,
} from "@mui/material";
import AppBreadcrumbs from "../../../components/AppBreadcrumbs";
import * as services from "../../../services/saleng";
import moment from "moment";
import "moment/locale/th";

moment.locale("th");

const ReportSummaryDetail = () => {
  const [transaction, setTransaction] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { transactionId } = useParams();

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setError(null);
      try {
        const res = await services.getTransaction(transactionId);
        console.log("res", res);
        const transactionRes = res.data.data;
        setTransaction(transactionRes || []);
      } catch (err) {
        setError(err.message || "Unknown error");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [transactionId]);

  const rows = transaction?.items?.map((t, index) => {
    console.log("t: ", t);
    return {
      id: index,
      productName: t.productName,
      netWeight: t.netWeight,
      pricePerUnit: formatNumber(t.pricePerUnit || 0),
      netPrice: formatNumber(t.netPrice || 0),
      impurityWeight: t.impurityWeight,

      // billNumber: t.billNumber,
      // customerName: t.customerName,
      // status: t.status,
      // paymentMethod: t.paymentMethod ?? "-",
      // totalNetPrice: formatNumber(t.totalNetPrice || 0),
      // createdAt: moment(t.createdAt)
      //   .add(543, "year")
      //   .format("D MMM YYYY เวลา HH:mm"),
      // createdAtDateOnly: moment(t.updatedAt).format("YYYY-MM-DD"),
    };
  });

  const columns = [
    {
      field: "productName",
      headerName: "ชื่อสินค้า",
      flex: 2,
    },
    {
      field: "netWeight",
      headerName: "น้ำหนักสุทธิ",
      flex: 2,
    },
    {
      field: "pricePerUnit",
      headerName: "ราคาต่อหน่วย",
      flex: 2,
    },
    {
      field: "netPrice",
      headerName: "ราคาสุทธิ",
      flex: 2,
    },
  ];

  if (loading) return <Box sx={{ p: 2 }}>Loading transcation...</Box>;
  if (error) return <Box sx={{ p: 2, color: "red" }}>Error: {error}</Box>;

  return (
    <Box p={2}>
      <AppBreadcrumbs />
      <Typography variant="h6" sx={{ my: 2 }}>
        รายละเอียด
      </Typography>

      <p
        style={{
          display: "flex",
          justifyContent: "center",
          margin: 10,
        }}
      >
        ข้อมูลรายการ
      </p>
      <Grid2 container spacing={2}>
        <Grid2 size={6}>
          <TextField
            id="standard-basic"
            label="เลขบิล"
            variant="standard"
            value={transaction?.billNumber || ""}
            fullWidth
          />
        </Grid2>
        <Grid2 size={3}>
          <TextField
            id="standard-basic"
            label="วันที่"
            variant="standard"
            value={
              moment(transaction.createdAt)
                .add(543, "year")
                .format("D MMM YYYY เวลา HH:mm") || ""
            }
            fullWidth
          />
        </Grid2>
        <Grid2 size={3}>
          <TextField
            id="standard-basic"
            label="สาขา"
            variant="standard"
            value={transaction?.branch?.name || ""}
            fullWidth
          />
        </Grid2>
        <Grid2 size={3}>
          <TextField
            id="standard-basic"
            label="ชื่อลูกค้า"
            variant="standard"
            value={transaction?.customerName || ""}
            fullWidth
          />
        </Grid2>
        <Grid2 size={2}>
          <TextField
            id="standard-basic"
            label="น้ำหนักสุทธิ"
            variant="standard"
            value={formatNumber(transaction?.totalWeight || 0)}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">กิโล</InputAdornment>
                ),
              },
            }}
            fullWidth
          />
        </Grid2>
        <Grid2 size={2}>
          <TextField
            id="standard-basic"
            label="ราคาสุทธิ"
            variant="standard"
            value={formatNumber(transaction?.totalNetPrice || 0)}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">บาท</InputAdornment>
                ),
              },
            }}
            fullWidth
          />
        </Grid2>
      </Grid2>

      <br />
      <br />
      <p
        style={{
          display: "flex",
          justifyContent: "center",
          margin: 10,
        }}
      >
        รายละเอียดสินค้า
      </p>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5]}
        disableRowSelectionOnClick
      />
    </Box>
  );
};

export default ReportSummaryDetail;
